module.exports = __webpack_public_path__ + "assets/570fca2b279d0556cb2935e9905909f7.mp3";